
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/transfer/refunds",
      function () {
        return require("private-next-pages/docs/api/products/transfer/refunds.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/transfer/refunds"])
      });
    }
  